export const CHAT_NEW_GROUP = 'CHAT_NEW_GROUP';
export const CHAT_NEW_MESSAGE = 'CHAT_NEW_MESSAGE';
export const CHAT_NEW_PENDING = 'CHAT_NEW_PENDING';
export const CHAT_REMOVE_GROUP_INVITE = 'CHAT_REMOVE_GROUP_INVITE';
export const CHAT_REMOVE_PENDING = 'CHAT_REMOVE_PENDING';
export const CHAT_UPDATE_MESSAGES = 'CHAT_UPDATE_MESSAGES';
export const CHAT_REMOVE_WORKORDER = 'CHAT_REMOVE_WORKORDER';
export const CHAT_ADD_WORKORDER = 'CHAT_ADD_WORKORDER';